import {
  ArrowRightIcon,
  Box,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
  Text,
} from '@razorpay/blade/components';
import { useSalaryComponentHelpers } from 'components/SalaryComponents/hooks';
import { EarningComponentSetting, SalaryComponent } from 'components/SalaryComponents/types';
import React from 'react';

interface ComponentsTableProps {
  components: SalaryComponent[];
  selectedIds: string[];
  onSelectionChange: (selectedIds: string[]) => void;
}

const ComponentsTable: React.FC<ComponentsTableProps> = ({
  components,
  selectedIds,
  onSelectionChange,
}) => {
  const getComponentType = (component: SalaryComponent): string => {
    if (component.category === 'EARNINGS_CATEGORY') {
      const payType = (component.settings as EarningComponentSetting)?.earningDetails?.payType;
      if (payType === 'non_payable_benefit') {
        return 'Non-Payable Benefit';
      }
      return `Earning (${payType === 'variable' ? 'Variable' : 'Monthly'})`;
    }
    return '';
  };

  const { getDetailsViewURL } = useSalaryComponentHelpers();

  return (
    <Table
      data={{ nodes: components }}
      showBorderedCells={false}
      selectionType="multiple"
      backgroundColor="transparent"
      onSelectionChange={(e) => {
        onSelectionChange(e.selectedIds.map((id) => id.toString()));
      }}
      defaultSelectedIds={selectedIds}>
      {(tableData) => (
        <>
          <TableHeader>
            <TableHeaderRow>
              <TableHeaderCell>Component</TableHeaderCell>
              <TableHeaderCell>Description</TableHeaderCell>
              <TableHeaderCell>Details</TableHeaderCell>
            </TableHeaderRow>
          </TableHeader>
          <TableBody>
            {tableData.map((component) => (
              <TableRow
                item={component}
                key={component.id}
                testID={`${component.name}-${
                  selectedIds.includes(component.id) ? 'selected' : 'unselected'
                }`}>
                <TableCell>
                  <Box>
                    <Text weight="semibold">{component.name}</Text>
                    <Text size="xsmall" color="surface.text.gray.muted">
                      {getComponentType(component)}
                    </Text>
                  </Box>
                </TableCell>
                <TableCell>
                  <Text color="surface.text.gray.muted">
                    {component.description || 'No description available'}
                  </Text>
                </TableCell>
                <TableCell>
                  <Link
                    href={getDetailsViewURL(component)}
                    target="_blank"
                    icon={ArrowRightIcon}
                    iconPosition="right">
                    Details
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </>
      )}
    </Table>
  );
};

export default ComponentsTable;
